import { createTypes, createAction } from 'lib/action'
const CREATE_REQUEST_MATERIAL = createTypes('createrequestmaterial', 'create')
const LOAD_REQUEST_MATEL = createTypes('requestmaterial', 'load')
const EXPORT_REQUEST_MATEL = createTypes('exportrequestmaterial', 'load')
// *load division
const REQUEST_MATERIAL_LOAD_DIVISION = createTypes(
  'requestmaterialloaddivision',
  'load'
)
// *load department
const REQUEST_MATERIAL_LOAD_DEPARTMENT = createTypes(
  'requestmaterialloaddepartment',
  'load'
)
// *load section
const REQUEST_MATERIAL_LOAD_SECTION = createTypes(
  'requestmaterialloadsection',
  'load'
)
// *load plant
const REQUEST_MATERIAL_LOAD_PLANT = createTypes(
  'requestmaterialloadplant',
  'load'
)
// *load material
const REQUEST_MATERIAL_LOAD_MATERIAL = createTypes(
  'requestmaterialloadmaterial',
  'load'
)

// *preview request material multiple plant
const REQUEST_MATERIAL_PREVIEW_REQUEST_MULTIPLE_PLANT = createTypes(
  'requestmaterialpreviewrequestmultipleplant',
  'load'
)

// *preview ticket
const REQUEST_MATERIAL_PREVIEW_TICKET_MULTIPLE_PLANT = createTypes(
  'requestmaterialpreviewticketmultipleplant',
  'load'
)

// *create ticket
const REQUEST_MATERIAL_CREATE_TICKET_MULTIPLE_PLANT = createTypes(
  'requestmaterialcreateticketmultipleplant',
  'load'
)

// *today action
const REQUEST_MATERIAL_TODAY_ACTION_MULTIPLE_PLANT = createTypes(
  'requestmaterialtodayactionmultipleplant',
  'load'
)

// *preview plant request multiple plant
const REQUEST_MATERIAL_PREVIEW_PLANT_REQUEST_MULTIPLE_PLANT = createTypes(
  'requestmaterialpreviewplantrequestmultipleplant',
  'load'
)

// *request realtime stock multiple plant
const REQUEST_REALTIME_STOCK_MULTIPLE_PLANT = createTypes(
  'requestrealtimestockmultipleplant',
  'load'
)

const REMOVE_LISTS = `REMOVE_LISTS`

function removeLists() {
  return {
    type: REMOVE_LISTS,
  }
}

const createRequestMaterial = {
  request: (data, loading) =>
    createAction(CREATE_REQUEST_MATERIAL.REQUEST, { data, loading }),
  success: (res) => createAction(CREATE_REQUEST_MATERIAL.SUCCESS, { res }),
  failure: () => createAction(CREATE_REQUEST_MATERIAL.FAITLURE),
}

const loadRequestMaterial = {
  request: (data, loading) =>
    createAction(LOAD_REQUEST_MATEL.REQUEST, { data, loading }),
  success: (lists, page, pageSize) =>
    createAction(LOAD_REQUEST_MATEL.SUCCESS, { lists, page, pageSize }),
  failure: () => createAction(LOAD_REQUEST_MATEL.FAILURE),
}

const exportRequestMaterial = {
  request: (data, loading) =>
    createAction(EXPORT_REQUEST_MATEL.REQUEST, { data, loading }),
  success: (lists, page) =>
    createAction(EXPORT_REQUEST_MATEL.SUCCESS, { lists }),
  failure: () => createAction(EXPORT_REQUEST_MATEL.FAILURE),
}

// *load division
const requestMaterialLoadDivision = {
  request: (data, loading) =>
    createAction(REQUEST_MATERIAL_LOAD_DIVISION.REQUEST, {
      data,
      loading,
    }),
  success: (lists) =>
    createAction(REQUEST_MATERIAL_LOAD_DIVISION.SUCCESS, { lists }),
  failure: () => createAction(REQUEST_MATERIAL_LOAD_DIVISION.FAITLURE),
}

// *load department
const requestMaterialLoadDepartment = {
  request: (data, loading) =>
    createAction(REQUEST_MATERIAL_LOAD_DEPARTMENT.REQUEST, {
      data,
      loading,
    }),
  success: (lists) =>
    createAction(REQUEST_MATERIAL_LOAD_DEPARTMENT.SUCCESS, { lists }),
  failure: () => createAction(REQUEST_MATERIAL_LOAD_DEPARTMENT.FAITLURE),
}

// *load section
const requestMaterialLoadSection = {
  request: (data, loading) =>
    createAction(REQUEST_MATERIAL_LOAD_SECTION.REQUEST, {
      data,
      loading,
    }),
  success: (lists) =>
    createAction(REQUEST_MATERIAL_LOAD_SECTION.SUCCESS, { lists }),
  failure: () => createAction(REQUEST_MATERIAL_LOAD_SECTION.FAITLURE),
}

// *load plant
const requestMaterialLoadPlant = {
  request: (data, loading) =>
    createAction(REQUEST_MATERIAL_LOAD_PLANT.REQUEST, {
      data,
      loading,
    }),
  success: (lists) =>
    createAction(REQUEST_MATERIAL_LOAD_PLANT.SUCCESS, { lists }),
  failure: () => createAction(REQUEST_MATERIAL_LOAD_PLANT.FAITLURE),
}

// *load material
const requestMaterialLoadMaterial = {
  request: (data, loading) =>
    createAction(REQUEST_MATERIAL_LOAD_MATERIAL.REQUEST, {
      data,
      loading,
    }),
  success: (lists) =>
    createAction(REQUEST_MATERIAL_LOAD_MATERIAL.SUCCESS, { lists }),
  failure: () => createAction(REQUEST_MATERIAL_LOAD_MATERIAL.FAITLURE),
}

// *preview request material multiple plant
const requestMaterialPreviewRequestMultiplePlant = {
  request: (data, loading) =>
    createAction(REQUEST_MATERIAL_PREVIEW_REQUEST_MULTIPLE_PLANT.REQUEST, {
      data,
      loading,
    }),
  success: (lists) =>
    createAction(REQUEST_MATERIAL_PREVIEW_REQUEST_MULTIPLE_PLANT.SUCCESS, {
      lists,
    }),
  failure: () =>
    createAction(REQUEST_MATERIAL_PREVIEW_REQUEST_MULTIPLE_PLANT.FAITLURE),
}

// *preview ticket multiple plant
const requestMaterialPreviewTicketMultiplePlant = {
  request: (data, loading) =>
    createAction(REQUEST_MATERIAL_PREVIEW_TICKET_MULTIPLE_PLANT.REQUEST, {
      data,
      loading,
    }),
  success: (lists) =>
    createAction(REQUEST_MATERIAL_PREVIEW_TICKET_MULTIPLE_PLANT.SUCCESS, {
      lists,
    }),
  failure: () =>
    createAction(REQUEST_MATERIAL_PREVIEW_TICKET_MULTIPLE_PLANT.FAITLURE),
}

// *create ticket multiple plant
const requestMaterialCreateTicketMultiplePlant = {
  request: (data, loading) =>
    createAction(REQUEST_MATERIAL_CREATE_TICKET_MULTIPLE_PLANT.REQUEST, {
      data,
      loading,
    }),
  success: (lists) =>
    createAction(REQUEST_MATERIAL_CREATE_TICKET_MULTIPLE_PLANT.SUCCESS, {
      lists,
    }),
  failure: () =>
    createAction(REQUEST_MATERIAL_CREATE_TICKET_MULTIPLE_PLANT.FAITLURE),
}

// *today action
const requestMaterialTodayActionMultiplePlant = {
  request: (data, loading) =>
    createAction(REQUEST_MATERIAL_TODAY_ACTION_MULTIPLE_PLANT.REQUEST, {
      data,
      loading,
    }),
  success: (lists) =>
    createAction(REQUEST_MATERIAL_TODAY_ACTION_MULTIPLE_PLANT.SUCCESS, {
      lists,
    }),
  failure: () =>
    createAction(REQUEST_MATERIAL_TODAY_ACTION_MULTIPLE_PLANT.FAITLURE),
}

// *preview plant request multiple plant
const requestMaterialPreviewPlantRequestMultiplePlant = {
  request: (data, loading) =>
    createAction(REQUEST_MATERIAL_PREVIEW_PLANT_REQUEST_MULTIPLE_PLANT.REQUEST, {
      data,
      loading,
    }),
  success: (lists) =>
    createAction(REQUEST_MATERIAL_PREVIEW_PLANT_REQUEST_MULTIPLE_PLANT.SUCCESS, {
      lists,
    }),
  failure: () =>
    createAction(REQUEST_MATERIAL_PREVIEW_PLANT_REQUEST_MULTIPLE_PLANT.FAITLURE),
}

// *request realtime stock multiple plant
const requestRealtimeStockMultiplePlant = {
  request: (data, loading) =>
    createAction(REQUEST_REALTIME_STOCK_MULTIPLE_PLANT.REQUEST, {
      data,
      loading,
    }),
  success: (lists) =>
    createAction(REQUEST_REALTIME_STOCK_MULTIPLE_PLANT.SUCCESS, {
      lists,
    }),
  failure: () =>
    createAction(REQUEST_REALTIME_STOCK_MULTIPLE_PLANT.FAITLURE),
}

export {
  CREATE_REQUEST_MATERIAL,
  createRequestMaterial,
  LOAD_REQUEST_MATEL,
  exportRequestMaterial,
  EXPORT_REQUEST_MATEL,
  loadRequestMaterial,
  REQUEST_MATERIAL_LOAD_DIVISION,
  requestMaterialLoadDivision,
  REQUEST_MATERIAL_LOAD_DEPARTMENT,
  requestMaterialLoadDepartment,
  REQUEST_MATERIAL_LOAD_SECTION,
  requestMaterialLoadSection,
  REQUEST_MATERIAL_LOAD_PLANT,
  requestMaterialLoadPlant,
  REQUEST_MATERIAL_LOAD_MATERIAL,
  requestMaterialLoadMaterial,
  REQUEST_MATERIAL_PREVIEW_REQUEST_MULTIPLE_PLANT,
  requestMaterialPreviewRequestMultiplePlant,
  REQUEST_MATERIAL_PREVIEW_TICKET_MULTIPLE_PLANT,
  requestMaterialPreviewTicketMultiplePlant,
  REQUEST_MATERIAL_CREATE_TICKET_MULTIPLE_PLANT,
  requestMaterialCreateTicketMultiplePlant,
  REQUEST_MATERIAL_TODAY_ACTION_MULTIPLE_PLANT,
  requestMaterialTodayActionMultiplePlant,
  REQUEST_MATERIAL_PREVIEW_PLANT_REQUEST_MULTIPLE_PLANT,
  requestMaterialPreviewPlantRequestMultiplePlant,
  REQUEST_REALTIME_STOCK_MULTIPLE_PLANT,
  requestRealtimeStockMultiplePlant,
  REMOVE_LISTS,
  removeLists,
}
